import React, { Component } from 'react';
import { Table, Row, Alert, Button, DatePicker, message, Spin } from 'antd';
import moment from 'moment';
import { inject, observer } from "mobx-react";
import dataDefault from './data';
import imgSave from "../../saveImg";
import Auth from "../../Auth";
import IsLableAuth from "../../IsLableAuth";
import ExportExcel from "@/method/components/ExportExcel";
import compute, { columns, fillData } from './compute';

const { MonthPicker } = DatePicker;

@inject('store')
@observer
class index extends Component {
    constructor(props) {
        super(props);
        this.state = {
            date: moment().subtract(1, 'month').format('YYYY-MM'),
            data: [],
            loading: true,
            loadingSave: false,
            print: false,
            isEdit: false,
            last: []
        }
    }


    componentDidMount() {
        this.getDateData(this.state.date);
    }

    computeNum = (data) => {
        data = compute(data, this.state.last);
        this.setState({
            data
        });
    }
    onChange = (name, value, i) => {
        let data = this.state.data;
        data[i][name] = value;
        this.computeNum(data);
        this.setState({ isEdit: true });
    }

    getDateData = async (date) => {
        try {
            const dataBegin = JSON.stringify(dataDefault);
            let data = JSON.parse(dataBegin);
            let res = await fetch(`/t5Lst?year=${moment(date).format('YYYY')}&month=${moment(date).format('M')}`, { credentials: 'include' });
            let x = await res.json();

            if (x.data.data && x.data.data.length > 0) {
                data = x.data.data.sort((a, b) => a.sort - b.sort);
            }
            data = fillData(data, x.data, date);

            this.setState({ loading: false, last: x.data.last });
            this.computeNum(data, x.data);

        } catch (error) {
            this.setState({ loading: false });
            console.error(error);
        }
    }

    onSave = () => {
        this.setState({ loadingSave: true });
        let date = this.state.date;
        if (!date) {
            message.error('请选择年份月份');
            let timer = setTimeout(() => { this.setState({ loadingSave: false }); clearTimeout(timer) }, 1000)
            return
        }
        let year = moment(date).format("YYYY");
        let month = moment(date).format("M");
        let data = this.state.data.map((x, i) => ({ ...x, year, month, }));

        let dataFrom = new FormData();
        dataFrom.append('data', JSON.stringify(data));
        let headres = {
            method: 'post',
            credentials: 'include',
            headers: {},
            body: dataFrom
        }
        fetch('/t5Save  ', headres).then(x => x.json()).then(x => {
            let timer = setTimeout(() => { this.setState({ loadingSave: false, isEdit: false }); clearTimeout(timer) }, 1000)
            if (x.status == 1) {
                message.success(x.msg);
                if (!data[0].id) {
                    this.getDateData(this.state.date);
                }
                return
            }
            message.error(x.msg);
        }).catch(err => {
            let timer = setTimeout(() => { this.setState({ loadingSave: false }); clearTimeout(timer) }, 1000)
            console.error(err);
            message.error('保存失败' + JSON.stringify(err));
        })
    }

    downloadSG = () => {
        this.setState({ print: true, loading: true }, () => {
            imgSave('table5_1_1', 1.5, '5.00', this.state.date).then(x => {
                if (x.status == 1) {
                    message.info('添加成功！');
                } else {
                    message.error('添加失败' + x.msg);
                }
                this.setState({
                    print: false,
                    loading: false
                });
            }).catch(err => {
                console.error(err);
                this.setState({
                    print: false,
                    loading: false
                });
            })
        });
    }

    render() {
        const { data, date, print } = this.state;

        return (
            <Spin spinning={this.state.loading}>
                <div className="table7_1_1">
                    <Row className="title" style={{ width: this.state.print ? 3800 : 'auto' }}>
                        <Row>5.0 F&B Summary 餐饮关键绩效指数</Row>
                        <Row className="table-month">
                            <MonthPicker
                                placeholder="请选择年月"
                                monthCellContentRender={(date, local) => {
                                    return moment(date).format('M月')
                                }}
                                defaultValue={moment(this.state.date, "YYYY-MM")}
                                format="YYYY-MM"
                                onChange={(date, str) => {
                                    this.setState({
                                        date: str,
                                        data: [],
                                        loading: true
                                    });
                                    this.getDateData(str)
                                }}
                            />
                        </Row>
                        <Table
                            columns={columns({ print, onChange: this.onChange })}
                            dataSource={data}
                            size="middle"
                            bordered
                            pagination={false}
                            className="content"
                            id="table5_1_1"
                            style={{ width: this.state.print ? 3800 : 'auto' }}
                            scroll={this.state.print ? {} : { x: 3800, y: 500 }}
                            rowKey={(record, index) => index}
                        />
                    </Row>

                    <Row className="table-footer-btn">
                        <Alert
                            message={
                                <div>
                                    表格关联
                                    <IsLableAuth auth="read_1" {...this.props} path="/table/1">1.1</IsLableAuth> -
                                    <IsLableAuth auth="read_7_1" {...this.props} path="/table/7_1">7.1</IsLableAuth> -
                                    <IsLableAuth auth="read_7_7" {...this.props} path="/table/7_7">7.7</IsLableAuth> -
                                    <IsLableAuth auth="read_7_8" {...this.props} path="/table/7_8">7.8</IsLableAuth>
                                </div>
                            }
                            type="info"
                            showIcon
                            style={{ display: "inline-block", marginRight: 10 }}
                        />
                        <Button
                            type="primary"
                            style={{ marginRight: 10 }}
                            onClick={() => {

                                this.setState({ print: true, loading: true }, () => {
                                    ExportExcel({
                                        id: "table5_1_1",
                                        date,
                                        name: "5.0 F&B Summary 餐饮关键绩效指数"
                                    });
                                    this.setState({ print: false, loading: false });
                                });

                            }}
                            loading={this.state.print}
                        >导出Excel</Button>
                        <Auth loading={this.state.loading} auth="edit_5_0">
                            <Button
                                type="primary"
                                style={{ marginRight: 10 }}
                                onClick={this.downloadSG}
                                loading={this.state.print}
                            >加入pdf</Button>
                            <Button
                                type="primary"
                                onClick={this.onSave}
                                loading={this.state.loadingSave}
                            >保存</Button>
                        </Auth>
                    </Row>

                </div>
            </Spin >
        );
    }
}

export default index;


// WEBPACK FOOTER //
// ./src/components/table/5.0/5/index.js